import { Analytics, AnalyticsBrowser } from '@segment/analytics-next';
import React from 'react';
const writeKey = process.env.VITE_SEGMENT_WRITE_KEY!;

export const useSegment = () => {
  const [analytics, setAnalytics] = React.useState<Analytics | undefined>(
    undefined
  );

  React.useEffect(() => {
    const loadAnalytics = async () => {
      let [response] = await AnalyticsBrowser.load({ writeKey });
      setAnalytics(response);
    };
    loadAnalytics();
  }, []);

  React.useEffect(() => {
    if (analytics) {
      analytics.page();
    }
  }, [location]);

  return analytics;
};
